const Img1 = '/assets/images/banner/animation/1.png';
const Img2 = '/assets/images/banner/animation/2.png';
const Img3 = '/assets/images/banner/animation/3.png';
const Img4 = '/assets/images/banner/animation/4.png';
const Img5 = '/assets/images/banner/animation/5.png';
const Img6 = '/assets/images/banner/animation/6.png';
const Img7 = '/assets/images/banner/animation/7.png';
const Img8 = '/assets/images/banner/animation/8.png';
const Img9 = '/assets/images/banner/animation/9.png';

const BannerBackgroundImages = [
  { img: Img1 },
  { img: Img2 },
  { img: Img3 },
  { img: Img4 },
  { img: Img5 },
  { img: Img6 },
  { img: Img7 },
  { img: Img8 },
  { img: Img9 },
];

export default BannerBackgroundImages;
